module.exports = __webpack_public_path__ + "9788f41e/img/placeholder.888fcd0b.svg";